module.exports = __webpack_public_path__ + "static/media/dracula3.f23b2bbc.png";